import {RoomBaseApiService} from "@/core/service/room.baseapi.service";
import {ErrorWrapper, ResponseWrapper} from "@/core/service/util";

export class RoomGroupService extends RoomBaseApiService {

    async getRoomGroupList() {
        try {
            const response = await this.request().get(`/api/v3/room/${this.getRoomId()}/group/list`)
            return new ResponseWrapper(response, response.data.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }

    async setRoomUserGroup(roomGroup) {
        try {
            const response = await this.request({ auth: true }).post(`/api/v3/room/${this.getRoomId()}/group/user`,
                roomGroup
            )
            return new ResponseWrapper(response, response.data.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }

    async startRoomGroup({roomGroupList, useContentLayout = true, hideRoomGroupUserInFilmArea = true}) {
        try {
            const response = await this.request({ auth: true }).post(`/api/v3/room/${this.getRoomId()}/group/start`,
                {roomGroupList, useContentLayout, hideRoomGroupUserInFilmArea}
            )
            return new ResponseWrapper(response, response.data.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }
    async createRoomGroup(roomGroup) {
        try {
            const response = await this.request({ auth: true}).post(`/api/v3/room/${this.getRoomId()}/group`,
                roomGroup
            )
            return new ResponseWrapper(response, response.data.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }

    }

    async createAndStartRoomGroup({roomGroupList, useContentLayout = true, hideRoomGroupUserInFilmArea = true}) {
        try {
            const response = await this.request({ auth: true}).post(`/api/v3/room/${this.getRoomId()}/group/createAndStart`,
                {roomGroupList, useContentLayout, hideRoomGroupUserInFilmArea}
            )
            return new ResponseWrapper(response, response.data.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }

    async endRoomGroup(roomGroupId) {
        try {
            const response = await this.request({ auth: true}).post(`/api/v3/room/${this.getRoomId()}/group/end?roomGroupId=${roomGroupId||''}`)
            return new ResponseWrapper(response, response.data.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }

    async addRoomGroup(roomGroupList) {
        try {
            const response = await this.request({ auth: true}).post(`/api/v3/room/${this.getRoomId()}/group/add`,
                roomGroupList
            )
            return new ResponseWrapper(response, response.data.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }

    async removeRoomGroup(roomGroupList) {
        try {
            const response = await this.request({ auth: true}).post(`/api/v3/room/${this.getRoomId()}/group/remove`,
                roomGroupList
                )
            return new ResponseWrapper(response, response.data.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }

    async eraseRoomGroupUser({userId, roomGroupId}) {
        try {
            const response = await this.request({ auth: true}).
            post(`/api/v3/room/${this.getRoomId()}/group/user/erase`,
                {userId, roomGroupId}
            )
            return new ResponseWrapper(response, response.data.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }

    async regRoomGroupSubject(roomGroupSubjectList) {
        try {
            const response = await this.request({ auth: true}).
            post(`/api/v3/room/${this.getRoomId()}/group/subject`,
                roomGroupSubjectList
            )
            return new ResponseWrapper(response, response.data.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }

    async removeRoomGroupSubject(roomGroupId) {
        try {
            const response = await this.request({ auth: true}).
            delete(`/api/v3/room/${this.getRoomId()}/group/${roomGroupId}/subject`)
            return new ResponseWrapper(response, response.data.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }

    async addRoomGroupsDurationTime(roomGroupDurationList) {
        try {
            const response = await this.request({ auth: true}).
            post(`/api/v3/room/${this.getRoomId()}/group/duration/add`,
                roomGroupDurationList
            )
            return new ResponseWrapper(response, response.data.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }

    async changeRoomGroupState({roomGroupId, state}) {
        try {
            const response = await this.request({ auth: true}).
            post(`/api/v3/room/${this.getRoomId()}/group/${roomGroupId}/state`, {state})
            return new ResponseWrapper(response, response.data.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }

    async changeRoomGroupMicMuteState(data) {
        try {
            const response = await this.request({ auth: true}).
            post(`/api/v3/room/${this.getRoomId()}/group/mic/mute`, data)
            return new ResponseWrapper(response, response.data.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }
    async changeRoomGroupSpeakerMuteState(data) {
        try {
            const response = await this.request({ auth: true}).
            post(`/api/v3/room/${this.getRoomId()}/group/speaker/mute`, data)
            return new ResponseWrapper(response, response.data.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }

    async changeHideRoomGroupUserInFilmArea(data) {
        try {
            const response = await this.request({ auth: true}).
            post(`/api/v3/room/${this.getRoomId()}/group/changeHideRoomGroupUserInFilmArea`, data)
            return new ResponseWrapper(response, response.data.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }
}

export const roomGroupService = new RoomGroupService()
